var map = {
	"./dog.svg": "7536",
	"./dragon.svg": "21c2",
	"./goat.svg": "e635",
	"./horse.svg": "1065",
	"./monkey.svg": "3c21",
	"./oxen.svg": "dea2",
	"./pig.svg": "cf3d",
	"./rabbit.svg": "ab5d",
	"./rat.svg": "5142",
	"./rooster.svg": "7e17",
	"./snake.svg": "7bfc",
	"./tiger.svg": "6ed3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "537d";